import { render, staticRenderFns } from "./BrakeoilClassroom4.vue?vue&type=template&id=248cb843&scoped=true"
import script from "./BrakeoilClassroom4.vue?vue&type=script&lang=js"
export * from "./BrakeoilClassroom4.vue?vue&type=script&lang=js"
import style0 from "./BrakeoilClassroom4.vue?vue&type=style&index=0&id=248cb843&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cb843",
  null
  
)

export default component.exports